$(document).ready(function () {
    $('.ajax-lazy-load').Lazy({
        beforeLoad: function (element) {
            // called before an elements gets handled
        },
        afterLoad: function (element) {
            // called after an element was successfully handled
            //console.log('afterLoad...', element);
            registerFormEvents(element);
            if (typeof $('.open-jobs-search-field').val() !== 'undefined' && $('.open-jobs-search-field').val().trim() !== '') {
                $('[data-trigger="filter-option"]').trigger('change');
            }
        },
        onError: function (element) {
            // called whenever an element could not be handled
        },
        onFinishedAll: function () {
            // called once all elements was handled
        }
    });

    /**
     * registerFormEvents
     * @param element
     */
    function registerFormEvents(element) {
        var $ajaxForm = element.find('form[data-submit="ajax"]');

        $ajaxForm.on('submit', function (event) {
            event.preventDefault();
            //console.log('AjaxForm captured onSubmit() event...');
            var that = $(this);
            var url = that.data('action');
            var data = $ajaxForm.serializeArray();
            // Add class indicating loading state:
            $ajaxForm.parent('div').addClass('is-loading');
            $.ajax({
                url: url,
                method: 'post',
                data: data,
                success: function (response) {
                    var $replaceEl = that.parents('div.ajax-lazy-load');
                    if($(response).find('div[data-trigger="reload"]').length > 0) {
                        // Perform page reload (e.g. on successful login)
                        location.reload();
                    }
                    // Remove class indicating loading state:
                    $ajaxForm.parent('div').removeClass('is-loading');
                    $replaceEl.html(response);
                    registerFormEvents($replaceEl);
                }
            });
            return false;
        });
    }

    $('[data-trigger="toggle-vacancybookmark"]').each(function(iterator, element) {
        $(this).on('click', function(e) {
            e.preventDefault();
            //console.log('click trigger bm ', $(this));
            var url = $(this).data('url');
            $.ajax({
                url: url,
                method: 'get',
                success: function (response) {
                    /*
                    var $replaceEl = that.parents('div.ajax-lazy-load');
                    $replaceEl.html(response);
                    */
                    //console.log('AJAX success ', response);
                }
            });

        })
    });


    $('[data-trigger="application-app"]').each(function(iterator, element) {
        ApplicationApp.init($(this));
    });

    $('[data-trigger="filterable-list"]').each(function(iterator, element) {
        FilterableList.init($(this));
    });
});

/**
 * FilterableList
 */
var FilterableList = {
    $rootElement: null,
    $filterOptions: [],
    $resultList: null,
    $swordInput: null,
    cssHiddenClass: 'd-none',
    ajaxUrl: null,
    ajaxRequest: null,
    swordMinLength: 2,
    init: function ($rootElement) {
        var appReference = this;
        this.$rootElement = $rootElement;
        this.$filterOptions = $rootElement.find('[data-trigger="filter-option"]');
        this.$resultList = $rootElement.find('[data-resultlist]');
        this.$swordInput = $rootElement.find('[data-sword]');
        this.ajaxUrl = this.$swordInput.parents('form').data('action');

        this.$swordInput.parents('form').on('submit', function(e) {
            e.preventDefault();
        });

        this.$filterOptions.on('change', function(e) {
            appReference.filterResults();
            appReference.filterOptions($(this));
        });

        this.$filterOptions.each(function(filterIterator, filterElement) {
            appReference.filterOptions($(this));
        });

        this.$swordInput.on('input', function() {
            if (appReference.ajaxRequest !== null) {
                appReference.ajaxRequest.abort();
            }
            if ($(this).val().length < appReference.swordMinLength && $(this).val().length != 0) {
                return;
            };
            // @todo: add 'modal'...
            var formData = $(this).parents('form').serializeArray();
            appReference.ajaxRequest = $.ajax({
                url:  appReference.ajaxUrl,
                method: 'post',
                data: formData,
                success: function (response) {
                    appReference.$rootElement.html(response);
                    appReference.init(appReference.$rootElement);
                    var searchField = $('.open-jobs-search-field');
                    var strLength = searchField.val().length * 2;
                    searchField.focus();
                    searchField[0].setSelectionRange(strLength, strLength);
                }
            });
        })
    },
    /**
     * disable options without results:
     * @param $currentOption
     */
    filterOptions: function($currentOption) {
        var appReference = this;
        this.$filterOptions.each(function(filterIterator, filterElement) {
            if ($(this).attr('name') === $currentOption.attr('name')) {
                // skip currentOption
                return true;
            }
            $(this).find('option').each(function(optionIterator, optionElement) {
                var field = $(filterElement).data('field');
                var value = $(this).val();
                if (value !== '') {
                    if (appReference.$resultList.find('[data-resultitem][data-'+field+'="'+value+'"]:visible').length > 0) {
                        $(this).prop('disabled', false);
                    } else {
                        $(this).prop('disabled', true);
                    }
                }
            });
        });
    },
    filterResults: function() {
        var appReference = this;
        this.$resultList.find('[data-resultitem]').hide();
        this.$resultList.find('[data-resultgroup] h4').hide();
        this.$resultList.find('[data-resultgroup] .line').hide();
        this.$resultList.find('[data-resultitem]').each(function(iterator, element) {
            var isMatching = true;
            appReference.$filterOptions.each(function(filterIterator, filterElement) {
                var field = $(this).data('field');
                var value = $(this).val();
                if (value != '' && $(element).attr('data-'+field) != value) {
                    isMatching = false;
                }
            });
            if (isMatching === true) {
                $(this).removeClass('cssHiddenClass');
                $(this).show();
            }
        });
        showJobListEntries();
    }
};


/**
 * ApplicationApp
 */
var ApplicationApp = {
    $rootElement: null,
    $formElement: null,
    fileUpload: null,
    videoUpload: null,
    init: function ($rootElement) {
        var appReference = this;
        this.$rootElement = $rootElement;
        this.$formElement = $rootElement.find('form');

        if ($rootElement.find('[data-trigger="fileupload-app"]').length) {
            this.fileUpload = Object.create(ApplicationFileUploadApp) ;
            this.fileUpload.init($('[data-trigger="fileupload-app"]'));
        }

        if ($rootElement.find('[data-trigger="videoupload-app"]').length) {
            this.videoUpload = Object.create(ApplicationVideoUploadApp) ;
            this.videoUpload.init($('[data-trigger="videoupload-app"]'));
        }

        var $referrer = this.$formElement.find('#referrer');
        if ($referrer.length) {
            $referrer.on('change', this.onReferrerChange);
        }

        this.$formElement.on('submit', function(e) {
            e.preventDefault();
            //console.log('ApplicationApp submit form', e);
            if (appReference.$rootElement.find('[data-upload]').length > 0) {
                // appReference.$rootElement.find('[data-uploadbutton]').trigger('click');
                return false;
            } else {
                appReference.$formElement.off('submit');
                appReference.$formElement.submit();
            }
        });
    },
    onReferrerChange: function (e) {
        var $target = $(e.target),
            $employeeRecommendation = ApplicationApp.$formElement.find('#employeeRecommendation'),
            value = $target.val();

        if (value === 'Mitarbeiterempfehlung') {
            $employeeRecommendation.show();
            $employeeRecommendation.prop('required',true);
        } else {
            $employeeRecommendation.hide();
            $employeeRecommendation.prop('required',false);
        }
    },
    validateFormdata: function() {
        // @todo: FE validation:
        //console.log('todo: FE validation');
        return true;
    }
};



/**
 * FileUploadApp
 */
var FileUploadApp = {
    $rootElement: null,
    $formElement: null,
    $targetFieldElement: null,
    $dropzoneElement: null,
    $filelistTableElement: null,
    //$progressContainer: null,
    uploadBaseUrl: null,
    attachmentTypes: [],
    userFiles: [],
    isUploading: false,
    options: {
        maxFiles: 9,
        acceptFileTypes: /$/i,
        maxFileSize: undefined,
        maxNumberOfFiles: undefined,
        acceptAttachmentTypes: [],
        userFilesJson: null
    },

    /**
     * init
     * @param $rootElement
     */
    init: function ($rootElement) {
        var appReference = this;
        this.$rootElement = $rootElement;
        this.$formElement = $rootElement.parents('form');
        this.$submitButton = $rootElement.parents('form').find('input[type="submit"]');
        this.$targetFieldElement = $rootElement.find('[data-fileupload-targetfield]');
        this.$dropzoneElement = $rootElement.find('[data-dropzone]');
        this.$filelistTableElement = $rootElement.find('[data-fileupload-files]');
        //this.$progressContainer = $rootElement.find('[data-progress]');
        this.uploadBaseUrl = $rootElement.data('uploadbaseurl');
        this.attachmentTypes = window.attachmentTypes;
        this.options.maxFileSize = $rootElement.data('maxfilesize');
        this.options.maxNumberOfFiles = $rootElement.data('maxnumberoffiles');
        this.options.acceptFileTypes = new RegExp('(\\.|\\/)(' +  $rootElement.data('acceptfiletypes').split(',').join('|') + ')$', 'i');
        if (this.options.userFilesJson != null) {
            this.userFiles = JSON.parse(this.options.userFilesJson);
            $.each(this.userFiles, function (index, file) {
                appReference.addUserAttachmentRow(file, appReference.$filelistTableElement);
            });
        }

        // register events for drag / drop / leave:
        this.$dropzoneElement.on({
            'dragover dragenter': function(e) {
                if(!$(this).hasClass('dragging')) {
                    $(this).addClass('dragging');
                }
            },
            'dragleave drop': function(e) {
                $(this).removeClass('dragging');
            }
        });

// @todo: move to 'ApplicationApp':
        // Don't submit form during file-upload:
        this.$formElement.on('submit', function(e) {
            //console.log('FileUploadApp submit form');
            if (appReference.isUploading) {
                e.preventDefault();
            }
        });
        /*
        this.$formElement.on("fileuploadstart", function(e) {
            appReference.$submitButton.prop('disabled', true);
            appReference.isUploading = true;
            //appReference.trigger('requestStart', true);
        });
        this.$formElement.on("fileuploadstop", function(e) {
            appReference.$submitButton.prop('disabled', false);
            appReference.isUploading = false;
            //appReference.trigger('requestStart', false);
        });
        */

        this.$targetFieldElement.fileupload({
            url: appReference.uploadBaseUrl,
            dataType: 'json',
            autoUpload: true,
            acceptFileTypes: appReference.options.acceptFileTypes,
            maxFileSize: appReference.options.maxFileSize,
            maxNumberOfFiles: appReference.options.maxNumberOfFiles,
            dropZone: appReference.$dropzoneElement,
            sequentialUploads: true,
        })
        .on('fileuploadadd', function (e, data) {
            //console.log('on fileuploadadd');
            appReference.addUserUploadRow(data);
        })
        .on('fileuploadstart', function (e, data) {
            //console.log('on fileuploadstart');
        })
        .on('fileuploadprocessalways', function (e, data) {
            //console.log('on fileuploadprocessalways');
            var index = data.index,
                file = data.files[index],
                node = $(data.context.children()[index]);
            if (file.error) {
                node
                .append('<br>')
                .append($('<span class="text-danger"/>').text(file.error));
            }
            if (index + 1 === data.files.length) {
                data.context.find('button[data-uploadbutton]')
                .text('')
                .attr('title', TYPO3.lang['feUserApplication.fileUpload.upload'])
                .prop('disabled', !!data.files.error);
            }
        }).on('fileuploadprogress', function (e, data) {
            var uploadProgress = appReference.updateUploadProgress(data);
        }).on('fileuploaddone', function (e, data) {
            //console.log('on fileuploaddone');
            $.each(data.result.files, function (index, file) {
                appReference.addUserAttachmentRow(file, data.context, true);
                if (file.error) {
                    var error = $('<span class="text-danger"/>').text(file.error);
                    $(data.context.children()[index])
                    .append('<br>')
                    .append(error);
                }
            });
        }).on('fileuploadfail', function (e, data) {
            //console.log('on fileuploadfail', data);

            var errorMessage = 'File upload failed.';
            try {
                var responseText = JSON.parse(data.jqXHR.responseText);
                errorMessage = responseText.message;
            } catch (e) {
                //
            }

            // clear progress info
            data.context.find('td[data-progress]').html('');

            $.each(data.files, function (index) {
                var error = $('<span class="text-danger"/>').text(errorMessage);
                $(data.context).find('[data-uploadbutton]').remove();
                $(data.context).find('select').remove();
                $(data.context.children()[index])
                .append('<br>')
                .append(error);
            });
        }).on('fileuploadsubmit', function (e, data) {
            // Add required formdata to upload request:
            if (data.formData == undefined) {
                data.formData = new Array();
            }
            data.formData.push({
                'name': 'tx_itemcareer_feuserprofile[application][vacancy]',
                'value': $('input[name="tx_itemcareer_feuserprofile[application][vacancy]"]').val()
            });
            data.formData.push({
                'name': 'tx_itemcareer_feuserprofile[__trustedProperties]',
                'value': $('input[name="tx_itemcareer_feuserprofile[__trustedProperties]"]').val()
            });
            // add 'currentattachmenttype' to ajax-formdata:
            var attachmenttypeParamName =  appReference.$formElement.find('[data-currentattachmenttype]').attr('name');
            var attachmenttypeValue = data.context.find('[name="attachmenttype[]"]').val();
            data.formData.push({
                'name': attachmenttypeParamName,
                'value': attachmenttypeValue
            });

            //console.log('serialized formData on fileuploadsubmit:', data.formData);
        }).prop('disabled', !$.support.fileInput)
        .parent().addClass($.support.fileInput ? undefined : 'disabled');
    },

    /**
     * addUserUploadRow
     * @param data
     */
    addUserUploadRow: function(data) {
        var appReference = this;
        data.context = $('<tr/>', {
            'data-upload': ''
        }).appendTo(appReference.$filelistTableElement);
        // add file icon
        $.each(data.files, function (index, file) {
            var tableCol = $('<td class="filename"/>')
            .append($('<span/>').text(file.name));
            tableCol.appendTo(data.context);

            if (appReference.options.acceptAttachmentTypes.length > 1) {
                var $selectAttachmenttype = $('<select class="fileselect" name="attachmenttype[]" />');
                $.each(appReference.attachmentTypes, function (it, el) {
                    if (el.value === 'TYPE_04' && !$.inArray(file.type, ['image/png', 'image/jpeg']) < 0) {
                        return true;
                    }

                    $('<option/>').attr('value', el.value).text(el.label).appendTo($selectAttachmenttype);
                });
            } else {
                var $selectAttachmenttype = $('<input type="hidden" name="attachmenttype[]" />');
                $selectAttachmenttype.val(appReference.options.acceptAttachmentTypes[0]);
            }
            var tableCol = $('<td class="selectbox"/>')
            .append($selectAttachmenttype);

            tableCol.appendTo(data.context);

            // Progress info
            var tableCol = $('<td/>', {
                'class': 'progress',
                'data-progress': ''
            });
            tableCol.appendTo(data.context);

            // Upload button
            var tableCol = $('<td class="file-upload-button"/>');
            var uploadButton = appReference.getUploadButton();
            tableCol
            .append(uploadButton.clone(true).data(data));

            var cancelButton = appReference.getCancelButton();
            tableCol
            .append(cancelButton.clone(true).data(data));

            tableCol.appendTo(data.context);

        });
    },

    /**
     * addUserAttachmentRow
     *
     * @param fileItem object
     * @param $context {*|jQuery|HTMLElement}
     * @param replaceContextBool bool
     * @returns void
     */
    addUserAttachmentRow: function(fileItem, $context, replaceContextBool) {
        var appReference = this;
        var replaceContext = (replaceContextBool === true);
        var tableRow = $('<tr/>').attr('data-filename', fileItem.fileName).attr('data-downloadurl', fileItem.downloadUrl);

        // Column: 'file name'
        var tableCol = $('<td class="filename"/>')
        .append($('<span/>').text(fileItem.originalFileName));
        tableCol.appendTo(tableRow);

        // Column: 'select attachmenttype'
        if (appReference.options.acceptAttachmentTypes.length > 1) {
            var $selectAttachmenttype = $('<select name="attachmenttype[]" />');
            $.each(this.attachmentTypes, function (it, el) {
                if (el.value === 'TYPE_04' && $.inArray(fileItem.fileType, ['image/png', 'image/jpeg']) < 0) {
                    return;
                }

                var option = $('<option/>').attr('value', el.value).text(el.label);
                option.appendTo($selectAttachmenttype);
            });

            if (fileItem.attachmentType) {
                $selectAttachmenttype.val(fileItem.attachmentType);
            }

            tableCol = $('<td class="selectbox"/>').append($selectAttachmenttype);
            tableCol.appendTo(tableRow);

            $selectAttachmenttype.on('change', function (e) {
                appReference.onUpdateRequest(e);
                var selectedValue = $(this).val();
                $.ajax({
                    url: window.updateAttachmentTypeBaseUrl,
                    method: 'post',
                    data: {
                        tx_itemcareer_feuserprofile: {
                            fileName: fileItem.fileName,
                            attachmentType: selectedValue
                        }
                    },
                    success: function (response) {
                        //console.log('success ', response);
                    }
                });
            });
        }

        // Column: 'action buttons'
        tableCol = $('<td class="file-upload-button"/>');
        var downloadButton = this.getDownloadButton();
        var deleteButton = this.getDeleteButton();
        //var uploadButton = this.getUploadButton();
        tableCol.append(downloadButton).append(deleteButton);
        tableCol.appendTo(tableRow);

        if (replaceContext === true) {
            $context.replaceWith(tableRow);
        } else {
            tableRow.appendTo($context);
        }
    },

    /**
     * onUpdateRequest
     * @param e
     */
    onUpdateRequest: function(e) {
        //console.log('updateRequest', e);
        // @todo: add backdrop
    },

    /**
     * getUploadButton
     * @returns {jQuery}
     */
    getUploadButton: function() {
        var uploadButton = $('<button/>', {
            'class': 'icon-upload btn-primary',
            'data-uploadbutton': '',
            'text': '',
            'title': 'Processing...'
        })
        .prop('disabled', true)
        .on('click', function (e) {
            e.preventDefault();
            //console.log('upload button clicked');
            var $this = $(this);
            var data = $this.data();
            $this
            .unbind('click')
            .text('')
            .attr('title', TYPO3.lang['feUserApplication.fileUpload.abort'])
            .on('click', function (e, d) {
                $this.remove();
                data.abort();
            });
            data.submit()
            .always(function () {
                // ...
            });
        });
        return uploadButton;
    },

    /**
     * getCancelButton
     * @returns {jQuery}
     */
    getCancelButton: function() {
        var cancelButton = $('<button/>', {
            'class': 'icon-trash btn-primary',
            'data-cancelbutton': '',
            'title': TYPO3.lang['feUserApplication.fileUpload.cancel'],
            'text': ''
        }).on('click', function () {
            var $this = $(this);
            var data = $this.data();
            data.context.remove();
        });
        return cancelButton;
    },

    /**
     * getDownloadButton
     * @returns {jQuery}
     */
    getDownloadButton: function() {
        var downloadButton = $('<button/>');
        downloadButton
        .addClass('icon-zip btn-primary')
        //.prop('disabled', true)
        .text('')
        .attr('title', TYPO3.lang['feUserApplication.fileUpload.download'])
        .on('click', function (e) {
            //console.log('download button on click');
            e.preventDefault();
            var $this = $(this);
            var downloadUrl = $this.parents('tr').data('downloadurl');
            window.location.href = downloadUrl;
        });
        return downloadButton;
    },

    /**
     * getDeleteButton
     * @returns {jQuery}
     */
    getDeleteButton: function() {
        var deleteButton = $('<button/>');
        deleteButton
        .addClass('icon-trash btn-primary')
        // .prop('disabled', true)
        .text('')
        .attr('title', TYPO3.lang['feUserApplication.fileUpload.delete'])
        .on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var filename = $this.parents('tr').data('filename');
            //console.log('on delete ', filename);
            $.ajax({
                url:  window.deleteAttachmentBaseUrl,
                method: 'post',
                data: {
                    tx_itemcareer_feuserprofile: {
                        fileName: filename
                    }
                },
                // @todo: handle success / errors:
                success: function (response) {
                    if (response.success) {
                        //console.log('remove parent tr');
                        //console.log('$this', $this);
                        $this.parents('tr').remove();
                    } else {
                        // @todo: handle error / show error message...
                    }
                }
            });
        });
        return deleteButton;
    },

    /**
     * updateUploadProgress
     * @param data
     */
    updateUploadProgress: function (data) {
        var progressPercentage = parseInt(data.loaded / data.total * 100, 10);
        var totalBytesFormated = '';
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        var totalBytes = data.total;
        if (totalBytes == 0)  {
            totalBytesFormated = '0 Byte';
        } else {
            var i = parseInt(Math.floor(Math.log(totalBytes) / Math.log(1024)));
            var totalBytesFormated =  Math.round(totalBytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        }
        var content = $('<span>').html(progressPercentage + '%');
        content.append($('<span>').html(totalBytesFormated));
        data.context.find('td[data-progress]').html(content);
    }
};


var ApplicationFileUploadApp = $.extend(
    {},
    FileUploadApp,
    {
        'options': {
            acceptAttachmentTypes: [
                'TYPE_01','TYPE_02','TYPE_03','TYPE_04','TYPE_99'
            ],
            userFilesJson: window.userFiles
        }
    }
);

var ApplicationVideoUploadApp = $.extend(
    {},
    FileUploadApp,
    {
        'options': {
            acceptAttachmentTypes: [
                'TYPE_11'
            ],
            userFilesJson: window.userVideos
        }
    }
);

//# sourceMappingURL=../maps/item24-karriere-base.min.js.map

//# sourceMappingURL=../maps/item24-karriere-base.min.js.map

//# sourceMappingURL=../maps/item24-karriere-base.min.js.map
